var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody1Right1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 955.84 728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-body-1 {\n        fill: #d61800;\n      }\n\n      .cls-body-2 {\n        fill: var(--custom-color, #fa) !important;\n      }\n\n      .cls-body-3 {\n        fill: #fff;\n      }\n\n      .cls-skin-color {\n      fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M586.75,61.86l-63.35,73.52,224.59,193.52c-5.07,10.71-8.5,22.42-9.87,34.87-6.56,59.94,36.72,113.84,96.65,120.4,59.94,6.56,113.84-36.72,120.4-96.65,6.56-59.94-36.72-113.84-96.65-120.4-11-1.2-21.8-.71-32.14,1.24l-239.64-206.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M691.21,138.54c-9.23-29.5-31.53-60.26-63.97-84.21-60.53-44.7-133.36-48.77-162.66-9.08-29.31,39.68-3.99,108.09,56.54,152.79,32.44,23.95,68.4,36.22,99.31,36.36l70.79-95.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-3",
    cx: 617.11,
    cy: 648.12,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-171.38 1071.4) rotate(-74.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 613.07,
    cy: 635.99,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-162.65 1058.58) rotate(-74.63)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-3",
    cx: 259.64,
    cy: 569.86,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-254.21 211.94) rotate(-30.65)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 265.15,
    cy: 558.32,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-247.56 213.14) rotate(-30.65)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M351.71,599.19c-132.47-46.31-227.2-143.03-240.15-257.23l-.03-.27c-1.45-12.91-1.58-25.93-.37-38.86l2.6-27.86c1.43.12,2.84.22,4.24.3,53.07,3.1,101.02-31.7,116.03-82.7l47.84-162.54h69.84s177.45,0,177.45,0h69.84s47.84,162.54,47.84,162.54c15.01,51,62.96,85.8,116.03,82.7,1.4-.08,2.81-.18,4.24-.3l2.58,27.59c1.22,13.11,1.1,26.31-.38,39.4h0c-7.86,69.33-45.87,132.22-104.17,181.3-68.25,57.46-155.48,86.81-244.7,86.27-25.48-.15-50.48-2.81-68.73-10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M400.92,132.35l-78.4-57.2-174.73,239.49c-11.09-4.19-23.04-6.66-35.55-7.02C51.97,305.94,1.74,353.43.04,413.7c-1.69,60.27,45.8,110.5,106.07,112.2,60.27,1.69,110.5-45.8,112.2-106.07.31-11.06-1.05-21.78-3.83-31.93l186.44-255.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M332.93,242.67c28.66-11.58,57.51-36.3,78.77-70.56,39.66-63.95,37.83-136.86-4.09-162.87-41.92-26-108.06,4.76-147.72,68.7-21.25,34.27-30.58,71.1-28.22,101.92l101.26,62.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody1Right1);
export default __webpack_public_path__ + "static/media/body1-right1.e86f48bc4996c77a098a09ce61ac214a.svg";
export { ForwardRef as ReactComponent };